import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { concatMap, Observable } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationBoxComponent } from '@modules/shell/components/confirmation-box/confirmation-box.component';

@Injectable()
export class DeleteInterceptor implements HttpInterceptor {

    constructor(private dialog: MatDialog) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

       if(req.method === "DELETE") {

            console.log("From delete http interceptor");
            return this.dialog.open(ConfirmationBoxComponent, {
                data: { confirm: true }
            }).afterClosed().pipe(
                concatMap( val =>  {
                    //console.log("val", val);
                    return next.handle(req);
                } )
            );

        } else {

            return next.handle(req);

        }
    }

}
